import './FleetTwentyFive.css';
import AIheader from "../../RentAI/AIheader";
import Footer from "../../../Component/Footer/Footer";
import ScrollingAnounce from "../../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce";
import EasySetup from "../../../Component/GetAroundpage/EasySetup/EasySetup";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import FleetTwentyFiveSlide from '../../../Component/Fleet/FleetTwentyFiveSlide/FleetTwentyFiveSlide';

const FleetTwentyFive = ()=> {

     
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    useEffect(() => {
      setIsClient(true);
    }, []);
  
    if (!isClient) return null;
   


    return (
        <>
            <AIheader/>

            {/* START bannerFleetMain */}
            <section className="bannerFleetMain">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-5">
                            <div className="bannerFleetLeft">
                                <h1>Supporting Fleets with<br/> <span>6-25 Vehicles</span></h1>
                                <h4>Unlocking Efficiency and Profitability</h4>
                                <p>Growing a rental fleet from a few vehicles to a mid-sized operation requires efficient management, smart automation, and strategic decision-making.</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="bannerFleetRight">
                                <figure>
                                    <img className='img-fluid' src="/img/Fleet/fleet_twenty_five_banner.webp" alt="6-25 Vehicles"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerCarRentalMain */}

 
            <FleetTwentyFiveSlide/>

            {/* START gigDeliveryMain */}
            <section className='gigDeliveryMain gigFleetFiveMain'>
                <div className='container-fluid'>
                    <div className="row jusify-content-center align-items-center">
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryLeft"> 
                                <h2>Smart Scaling for Mid-<br/>Sized Fleets</h2>
                                <p>Managing vehicles requires streamlined operations, automation, 
                                    and adaptable insurance. Whether you're expanding to new markets 
                                    or optimizing your fleet, Rentid provides the technology and 
                                    support for sustainable growth.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryRight" >
                                <img className='img-fluid' src="/img/Fleet/smart_scaling.webp" alt="Smart Scaling for Mid-Sized Fleets"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END gigDeliveryMain */}


            {/* START choiceFormerMain */}
            <section  className="choiceFormerMain choiceDesktopMain fleetFiveChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>How Rentid’s Core Products Support Growing Fleets</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs main-tabs-ai">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#choiceFormer_1">
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent direct"/>rent<span>direct</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_2">
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_3">
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent shield"/>rent<span>shield</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_4">
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent AI"/>rent<span>AI</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_5">
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent success"/>rent<span>success</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_6">
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent academy"/>rent<span>academy</span>
                                    </a>
                                </li>
                            </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className="tab-pane active" id="choiceFormer_1">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rent direct"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Efficient Fleet Oversight and Automation</h3>
                                                    <h4>Take full control of your rental operation with smart automation and data-driven insights.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Integrated Booking System</h5>
                                                            <small>Manage vehicle assignments and track reservations effortlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Pricing Optimizations</h5>
                                                            <small>Adjust rates automatically based on market demand, seasonal trends, and vehicle availability.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Custom Rental Policies</h5>
                                                            <small>Set mileage limits, deposit requirements, and penalty structures to ensure profitability.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fleet-Wide Performance Analytics</h5>
                                                            <small>Access real-time insights into revenue, utilizations, and market trends.</small>
                                                        </li>
                                                    </ul>
                                                </div>        

                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 1 */}

                                {/* START Tab 2 */} 
                                <div className="tab-pane fade" id="choiceFormer_2">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rent id"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Advanced Renter Verification and Security</h3>
                                                    <h4>Ensure every rental is secure with identity verification and risk assessment tools.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>DriverIQ™ Risk Score</h5>
                                                            <small>Evaluate renter reliability using AI-driven analysis.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated ID & Insurance Verification</h5>
                                                            <small>Instantly confirm guest identity and insurance validity.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Customizable Renter Approval</h5>
                                                            <small>Set screening thresholds to automate verification and reduce manual reviews.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fraud Detection & Incident Tracking</h5>
                                                            <small>Identify potential risks and maintain detailed renter history logs.</small>
                                                        </li>
                                                    </ul>
                                                </div>                                           
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentid">Learn About RentID
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 2 */}

                                {/* START Tab 3 */}
                                <div className="tab-pane fade" id="choiceFormer_3">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rent shield"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Insurance Solutions for Growing Fleets</h3>
                                                    <h4>Get flexible, scalable coverage that aligns with your business growth.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Per-Trip Rental Insurance</h5>
                                                            <small>Pay for coverage only when vehicles are rented.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fleet-Wide Insurance Plans</h5>
                                                            <small>Protect multiple vehicles under a single, cost-effective policy.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Seamless Digital Claims Processing</h5>
                                                            <small>Submit and track claims through the Rentid platform.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Custom Coverage Options</h5>
                                                            <small>Adjust policies based on vehicle value, rental frequency, and risk assessment.</small>
                                                        </li>
                                                    </ul>
                                                </div>                                           
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}

                                {/* START Tab 4 */} 
                                <div className="tab-pane fade" id="choiceFormer_4">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rent ai"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Automated Guest Interaction & Support</h3>
                                                    <h4>Reduce manual work and enhance customer experience with AI-driven automation.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>24/7 Virtual Rental Assistant</h5>
                                                            <small>Answer common renter questions, handle booking modifications, and process late return requests.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated Rental Agreements</h5>
                                                            <small>Generate and store contracts with renter-specific terms.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Custom Chatbot Workflows</h5>
                                                            <small>Personalized chatbot responses to align with business policies.</small>
                                                        </li>
                                                        <li>
                                                            <h5>AI-Powered Dispute Resolution</h5>
                                                            <small>Minimize conflicts with automated mediation tools</small>
                                                        </li>
                                                    </ul>
                                                </div>    
                                               <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 4 */}

                                {/* START Tab 5 */}
                                <div className="tab-pane fade" id="choiceFormer_5">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rent success"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Data-Driven Growth & Profitability Tools</h3>
                                                    <h4>Utilize analytics and strategic insights to enhance fleet performance.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Market-Based Pricing Recommendations</h5>
                                                            <small>Adjust rates in real-time based on market conditions.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fleet Utilization Metrics</h5>
                                                            <small>Monitor downtime, rental frequency, and revenue efficiency.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Targeted Marketing & Customer Acquisition</h5>
                                                            <small>Leverage digital campaigns to attract new renters.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Growth Strategy Consultation</h5>
                                                            <small>Access expert insights on expanding beyond 25 vehicles.</small>
                                                        </li>
                                                    </ul>
                                                </div>  
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 5 */}


                                {/* START Tab 6 */} 
                                <div className="tab-pane fade" id="choiceFormer_6">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rent academy"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Learning & Networking for Fleet Operators</h3>
                                                    <h4>Stay informed, connect with industry experts, and refine your rental strategy.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Fleet Management Training</h5>
                                                            <small>Access advanced resources on operations, compliance, and pricing.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Community Networking</h5>
                                                            <small>Engage with other fleet owners and industry professionals.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Strategic Growth Playbooks</h5>
                                                            <small>Learn best practices for scaling efficiently and profitably.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Live Webinars & Expert Workshops</h5>
                                                            <small>Participate in educational events led by industry leaders.</small>
                                                        </li>
                                                    </ul>
                                                </div>  
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 6 */}
                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceMobileMain */}
            <section  className="choiceFormerMain choiceMobileMain fleetFiveChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>How Rentid’s Core Products Support Growing Fleets</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="choiceAccordian">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent direct"/>rent<span>direct</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rent direct"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'>
                                                <h3>Efficient Fleet Oversight and Automation</h3>
                                                <h4>Take full control of your rental operation with smart automation and data-driven insights.</h4>
                                                <ul>
                                                    <li>
                                                        <h5>Integrated Booking System</h5>
                                                        <small>Manage vehicle assignments and track reservations effortlessly.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Dynamic Pricing Optimizations</h5>
                                                        <small>Adjust rates automatically based on market demand, seasonal trends, and vehicle availability.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Custom Rental Policies</h5>
                                                        <small>Set mileage limits, deposit requirements, and penalty structures to ensure profitability.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Fleet-Wide Performance Analytics</h5>
                                                        <small>Access real-time insights into revenue, utilizations, and market trends.</small>
                                                    </li>
                                                </ul>

                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rent Id"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                    <h3>Advanced Renter Verification and Security</h3>
                                                    <h4>Ensure every rental is secure with identity verification and risk assessment tools.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>DriverIQ™ Risk Score</h5>
                                                            <small>Evaluate renter reliability using AI-driven analysis.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated ID & Insurance Verification</h5>
                                                            <small>Instantly confirm guest identity and insurance validity.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Customizable Renter Approval</h5>
                                                            <small>Set screening thresholds to automate verification and reduce manual reviews.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fraud Detection & Incident Tracking</h5>
                                                            <small>Identify potential risks and maintain detailed renter history logs.</small>
                                                        </li>
                                                    </ul>
                                                                                        
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentid">Learn About RentID
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent shield"/>rent<span>shield</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rent shield"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                    <h3>Insurance Solutions for Growing Fleets</h3>
                                                    <h4>Get flexible, scalable coverage that aligns with your business growth.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Per-Trip Rental Insurance</h5>
                                                            <small>Pay for coverage only when vehicles are rented.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fleet-Wide Insurance Plans</h5>
                                                            <small>Protect multiple vehicles under a single, cost-effective policy.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Seamless Digital Claims Processing</h5>
                                                            <small>Submit and track claims through the Rentid platform.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Custom Coverage Options</h5>
                                                            <small>Adjust policies based on vehicle value, rental frequency, and risk assessment.</small>
                                                        </li>
                                                    </ul>
                                                
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 4 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent AI"/>rent<span>AI</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rent AI"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                    <h3>Automated Guest Interaction & Support</h3>
                                                    <h4>Reduce manual work and enhance customer experience with AI-driven automation.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>24/7 Virtual Rental Assistant</h5>
                                                            <small>Answer common renter questions, handle booking modifications, and process late return requests.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated Rental Agreements</h5>
                                                            <small>Generate and store contracts with renter-specific terms.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Custom Chatbot Workflows</h5>
                                                            <small>Personalized chatbot responses to align with business policies.</small>
                                                        </li>
                                                        <li>
                                                            <h5>AI-Powered Dispute Resolution</h5>
                                                            <small>Minimize conflicts with automated mediation tools</small>
                                                        </li>
                                                    </ul>
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 5 */}
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent success"/>rent<span>success</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rent success"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'> 
                                                <h3>Data-Driven Growth & Profitability Tools</h3>
                                                    <h4>Utilize analytics and strategic insights to enhance fleet performance.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Market-Based Pricing Recommendations</h5>
                                                            <small>Adjust rates in real-time based on market conditions.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fleet Utilization Metrics</h5>
                                                            <small>Monitor downtime, rental frequency, and revenue efficiency.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Targeted Marketing & Customer Acquisition</h5>
                                                            <small>Leverage digital campaigns to attract new renters.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Growth Strategy Consultation</h5>
                                                            <small>Access expert insights on expanding beyond 25 vehicles.</small>
                                                        </li>
                                                    </ul>
                                        
                                                 <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 6 */}
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent academy"/>rent<span>academy</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rent academy"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                    <h3>Learning & Networking for Fleet Operators</h3>
                                                    <h4>Stay informed, connect with industry experts, and refine your rental strategy.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Fleet Management Training</h5>
                                                            <small>Access advanced resources on operations, compliance, and pricing.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Community Networking</h5>
                                                            <small>Engage with other fleet owners and industry professionals.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Strategic Growth Playbooks</h5>
                                                            <small>Learn best practices for scaling efficiently and profitably.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Live Webinars & Expert Workshops</h5>
                                                            <small>Participate in educational events led by industry leaders.</small>
                                                        </li>
                                                    </ul>
                                
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                {/* end 6 */}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceMobileMain */}


            {/* START industryFleetFiveMain */}
            <section className='industryFleetFiveMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='industryFleetFiveHead'>
                                <h6>INDUSTRY SOLUTIONS</h6>
                                <h2>Solving Car Rental for Everyone</h2>
                                <p>Rentid makes car rental easy and simple for everyone, no matter your industry. 
                                Optimize every rental with a powerful, all-in-one back-office solution. Automate 
                                workflows, simplify management, and resolve issues seamlessly—so you can 
                                grow your business.</p>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-rental">
                                    <img className='img-fluid' src="/img/Fleet/car_black.svg" alt="Car Rental"/>
                                    <h3>Car Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-sharing">
                                    <img className='img-fluid' src="/img/Fleet/refresh_black.svg" alt="Car Sharing"/>
                                    <h3>Car Sharing</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                            <a href="/ride-sharing">
                                <img className='img-fluid' src="/img/Fleet/user_switch_black.svg" alt="Ride Share"/>
                                <h3>Ride Share</h3>
                            </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/delivery">
                                    <img className='img-fluid' src="/img/Fleet/spoon_black.svg" alt="Delivery Drivers"/>
                                    <h3>Delivery Drivers</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 2 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/auto-dealerships">
                                    <img className='img-fluid' src="/img/Fleet/car_parking_black.svg" alt="Auto Dealerships"/>
                                    <h3>Auto Dealerships</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/service-repair">
                                    <img className='img-fluid' src="/img/Fleet/wrench_black.svg" alt="Service & Repair"/>
                                    <h3>Service & Repair</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/vacation-rental">
                                    <img className='img-fluid' src="/img/Fleet/house_black.svg" alt="Vacation Rental"/>
                                    <h3>Vacation Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/hotel_black.svg" alt="Hotel & Resort"/>
                                    <h3>Hotel & Resort</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 3 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/building_black.svg" alt="Property Mgmt"/>
                                    <h3>Property Mgmt</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/tie_black.svg" alt="Corporate"/>
                                    <h3>Corporate</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/pentagon_black.svg" alt="Government"/>
                                    <h3>Government</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/teacher_black.svg" alt="Education"/>
                                    <h3>Education</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryFleetFiveMain */}

            {/* START industryTrustMain */}
            <section className="industryTrustMain">
                <div className="container">
                    <div className='industryTrustOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustLeft'>
                                    <h2>Industry trust<span> and transparency</span> </h2>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustRight'>
                                    <ul>
                                        <li>
                                            <img className="img-fluid" width="140px" src="/img/AnoucementPage/industryTrust_1.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="164px" src="/img/AnoucementPage/industryTrust_2.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="146px" src="/img/AnoucementPage/industryTrust_3.png" alt="Industry trust and transparency" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryTrustMain */}
 
            <EasySetup/> 

            {/* START expSolutionsMain */}
            <section className="expSolutionsMain expSolutions_25_Main">
                <div className="container">
                    <div className='expSolutionsOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='expSolutionsInner'>
                                    <h2>Explore Rentid’s Solutions for<br/> Fleets with 26-50 Vehicles</h2>
                                    <a className="btn btnWhite" href="/fleet-50">Learn More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END expSolutionsMain */}

            <ScrollingAnounce/>
            <Footer/>
        </>
    )
}

export default FleetTwentyFive;